<script lang="ts">
	// Format
	import { format } from 'svelte-i18n';
	import { capFirstChar } from 'src/helpers/utilities';
	// Design system components
	import { AlertV2, SelectV2, ToggleV2, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import {
		getInitLoadedPeriodStatistics,
		isPrevPeriodComparisonEnabled,
		rangeOptions,
	} from 'src/components/Chart/chart_control_helpers';
	import { save_home } from 'src/helpers/home_helpers';
	import { isPremiumUser } from 'src/helpers/user_helpers';

	let waitForResponseSavePrevious = false,
		waitForResponseInitPeriod = false,
		checked = isPrevPeriodComparisonEnabled(),
		chartPeriods = rangeOptions.filter(
			(i) =>
				!/^custom|billing_date|hour$/.test(i.period) || (i.period == 'hour' && isPremiumUser()),
		),
		initLoadedPeriod = getInitLoadedPeriodStatistics(chartPeriods);
	if (checked == null) checked = true;

	const savePreviousComparison = async () => {
		if (waitForResponseSavePrevious) return;
		waitForResponseSavePrevious = true;
		const prevPeriodComparison = !checked,
			res = await save_home('prev_period_comparison', {
				value: prevPeriodComparison,
			});
		if (res.isok) checked = prevPeriodComparison;
		onSettingsResponse(res);
		waitForResponseSavePrevious = false;
	};

	const saveChartInitLoadedPeriod = async (period: string) => {
		if (waitForResponseInitPeriod) return;
		waitForResponseInitPeriod = true;
		const res = await save_home('init_loaded_period_statistics', period);
		onSettingsResponse(res);
		waitForResponseInitPeriod = false;
	};
</script>

<!-- <Text styleType="body-small" class="mb-s "
	>{$format('text_app_settings_statistics_apply_global_chart_heading', {
		default:
			'All settings will be applied globally to all charts in the application message'
	})}</Text
> -->
<div class="d-flex justify-content-between align-items-center gap-m mb-m">
	<div class="min-width-0">
		<Text styleType="body" class="mb-s">
			{capFirstChar(
				$format('text_app_settings_menu_statistics', { default: 'Statistics Settings' }),
			)}
		</Text>
		<Text styleType="body-small" class="text-color-muted">
			{$format('toggle_app_settings_statistics_previous_period_comparison', {
				default: 'Show previous period comparison for energy statistics.',
			})}
		</Text>
	</div>

	<ToggleV2
		{checked}
		size="m"
		on:click={savePreviousComparison}
		id="toggle-671lel1"
		aria-label={$format('text_app_settings_menu_statistics', { default: 'Statistics Settings' })}
	/>
</div>

<AlertV2
	class="mb-s "
	heading={$format('alert_app_settings_statistics_apply_global_chart_heading', {
		default: 'All settings will be applied globally to all charts in the application message',
	})}
/>

<Text styleType="body-small" class="mb-s">
	{$format('text_app_settings_statistics_select_default_period', {
		default: 'Select the default initially loaded period',
	})}
</Text>
<SelectV2
	aria-label={$format('select_default_period', { default: 'Select default period' })}
	value={$format(`option_${initLoadedPeriod.period}`)}
	width="l"
	icon="fas fa-clock-rotate-left"
	class="width-md-l"
	options={chartPeriods.map((i) => $format(`option_${i.period}`))}
	on:change={(e) =>
		saveChartInitLoadedPeriod(
			chartPeriods.find((i) => $format(`option_${i.period}`) === e.detail)?.period,
		)}
	id="select-bpmyant"
/>
